import React, { useEffect, useState, useRef } from "react";
import { setBannerHeight } from "../actions";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import useMobile from "../../../../../hooks/useMobile";
// import MobileApp from "./mobile";
import Upgrade from "./upgrade";

import "./index.scss";


const Status = () => {

	const { pathname } = useLocation();
	const banners = useSelector(({ auth }) => auth.status);
	const [isStaging, setStaging] = useState(false);
	const [skipMobileBanner, setSkipMobileBanner] = useState(false);
	const [showUpgradeAlert, setShowUpgradeAlert] = useState(false);
	const isMobile = useMobile();
	const [isDashboard, setDashboard] = useState(false);
	const [status, setStatus] = useState([]);
	const ref = useRef();
	const bannerHeight = useSelector(({ nav }) => nav.bannerHeight);
	const dispatch = useDispatch();

	useEffect(() => {
		if(ref && ref.current) {
			dispatch(setBannerHeight(ref.current.offsetHeight))
		}
	}, [status.length, ref && ref.current, isMobile, isDashboard, skipMobileBanner, showUpgradeAlert])


	let data = [status.length, banners, isMobile, isDashboard, isStaging, skipMobileBanner, showUpgradeAlert, pathname, bannerHeight];

	useEffect(() => {

		if(window.location.host.includes('paylixecommerce-staging.io')) {
			document.body.classList.add('staging');
			setStaging(true);
		}

		if(window.location.host.includes('paylixecommerce-crispy.io')) {
			document.body.classList.add('staging');
			setStaging(true);
		}

		if(isStaging && !status.find(({ id }) => id === "BETA")) {
			status.unshift({
				id: "BETA",
				message: `This is a BETA release of Paylix. Please do not use it for important matters as bugs may be present [Click here](https://paylix.gg) to go to the live site.`
			});
			setStatus([...status]);
		}

		if(window.location.host.includes("dashboard")) {
			setDashboard(true);

			if(banners) {
				setStatus(banners)
			}
		}

	}, data);


	return <div className="status-wrapper" ref={ref}>

		{/* {isDashboard ? <MobileApp skipMobileBanner={skipMobileBanner} setSkipMobileBanner={setSkipMobileBanner} /> : null} */}

		{isDashboard ? <Upgrade showUpgradeAlert={showUpgradeAlert} setShowUpgradeAlert={setShowUpgradeAlert} /> : null}

		{(status || []).map(({ id, message, type }, key) => (
			<div className={`${type} status-alert`} key={key}>
				<ReactMarkdown>{message}</ReactMarkdown>
			</div>
		))}
	</div>
}


export default Status;
